import Button from '../Button';
import FormContainer from '../FormContainer';
import Input from '../Input';
import Typography from '../Typography';

const Filter = ({ label1, label2 }: any) => {
  const handleFilter = () => {};
  return (
    <div>
      <Typography style={{ marginBottom: '10px' }}>Filter by</Typography>
      <FormContainer label={label1}>
        <Input />
      </FormContainer>
      <FormContainer label={label2}>
        <Input />
      </FormContainer>
      <Button onClick={handleFilter}>Filter</Button>
    </div>
  );
};

export default Filter;
